/**
 * Manage adjust events at https://suite.adjust.com/apps/na3q7q6avq4g/events
 */
export const ADJUST_EVENT_TOKENS = {
  logWorkout: 'e3xe9l',
  purchase: 'qf1l8r',
  signupComplete: 'n46d1z',
  renewal: 'i5pcdz',
  updateSexMale: 'kbdp5b',
  updateSexFemale: 'jkkjka',
  updateSexOther: 'z4awr3',
  updateAge18Through28: 'o5f1gc',
  updateAge29Through44: 'vvhb17',
  updateAge45AndUp: '3meyo6',
};

export type AdjustEventToken = (typeof ADJUST_EVENT_TOKENS)[keyof typeof ADJUST_EVENT_TOKENS];
